import { motion } from "framer-motion";
import { Reveal } from "@/components/shared/Reveal";
import { PrimaryButton } from "@/components/shared/PrimaryButton";
import { CircuitBg } from "@/components/shared/CircuitBg";

export function CTA() {
  return (
    <section data-testid="cta-section" className="relative bg-navy text-white py-24 md:py-32 overflow-hidden">
      <CircuitBg className="absolute inset-0 w-full h-full" opacity={0.4} />
      <div className="absolute inset-0 grid-lines-dark opacity-40" />
      <div className="absolute -top-1/2 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-cyan/10 blur-[120px]" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-8 text-center">
        <Reveal>
          <h2 className="font-head font-extrabold tracking-tight text-4xl md:text-6xl lg:text-7xl max-w-4xl mx-auto leading-[1.02]">
            Bir sonraki projenizi <span className="text-cyan text-glow">birlikte</span> hayata geçirelim.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg text-silver/75 max-w-2xl mx-auto leading-relaxed">
            Elektrik, otomasyon veya mühendislik ihtiyaçlarınız için ekibimizle iletişime geçin.
          </p>
        </Reveal>
        <motion.div
          className="mt-12 flex justify-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <PrimaryButton to="/iletisim" data-testid="cta-button" className="text-base px-9 py-5">
            PROJENİZİ GÖRÜŞELİM
          </PrimaryButton>
        </motion.div>
      </div>
    </section>
  );
}
